import React from 'react';
import appState from "../../state/AppStateContainer";
import appEnum from "../../util/appEnum"
import AppLabel from "../app-label/app-label"
import $ from 'jquery'
import "./app-project-settings.css";
import { CustomAvatar } from '../../components/shared';
import { withTranslation } from 'react-i18next';

class AppProjectSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    if (props.currentProject) {
      this.state = this.updateState(props.currentProject);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.currentProject != nextProps.currentProject) {
      let state = this.updateState(nextProps.currentProject);
      this.setState(state);
    } else if (this.props.t !== nextProps.t) {
      const typeOfContract = nextProps.currentProject?.entreprenad;
      const projectType = nextProps.currentProject?.projectTypeName;
      this.setState({
        entreprenad: typeOfContract && appEnum.getEntreprenadValueByKey(typeOfContract, nextProps.t),
        projectType: projectType && this.props.t(`projectType.${projectType.replace(/[\s&/]/g, '')}`, projectType)
      });
    }
  }

  updateState(project) {
    const members = this.getMembers(project);
    return {
      name: project?.name,
      number: project?.number,
      responsible: project?.responsible,
      customer: project?.customer,
      province: project?.province,
      entreprenad: project?.entreprenad && appEnum.getEntreprenadValueByKey(project.entreprenad, this.props.t),
      estimatedCost: project && appEnum.getProjectCostValueByKey(project.estimatedCost),
      projectType: project?.projectTypeName && this.props.t(`projectType.${project.projectTypeName.replace(/[\s&/]/g, '')}`, project.projectTypeName),
      phase: project?.phase,
      members: members
    };
  }

  getMembers(project) {
    const {t} = this.props;
    if (!project) return [];
    if (!project.area) return project.user || [];
    const members = project.user || [];
    
    const projectMemberIds = new Set(members.map(m => m._id));
    
    if (project.area) {
      for (let ai = 0; ai < project.area.length; ai++) {
        const area = project.area[ai];
        if (area?.areaId?.members) {
          area.areaId.members = area.areaId.members.filter(dbMem => 
            projectMemberIds.has(dbMem._id)
          );
        }
      }
    }
        for (let ai = 0; ai < project.area.length; ai++) {
      const area = project.area[ai];
      for (let mi = 0; area?.areaId?.members && mi < area.areaId.members.length; mi++) {
        const dbMem = area.areaId.members[mi];
        let existingMember = members.find(m => (m._id) == dbMem._id);
        if (!existingMember) {
          let role = this.props.users ? this.props.users.find(u => u.value == dbMem._id).role : dbMem.role;
          if (role == 'Management') {
            role = t('settings.role.admin', 'Administratör');
          } else if (role == 'Inköp') {
            role = t('settings.role.user', 'Deltagare');
          } else if (role == 'Kalkyl') {
            role = t('settings.role.visitor', 'Besökare');
          }

          existingMember = {_id: dbMem._id, name: dbMem.name};
          members.push(existingMember);
        }
      }
    }

    return members;  
  }


  editProjectBtnCallback() {
    if (this.props.editProjectBtnCallback) {
      this.props.editProjectBtnCallback();
    }
  }

  dummyOnChange(e) {
  }

  expandMoreInfo(e) {
    $(e.target).addClass('expanded');
  }

  render() {
    const {t} = this.props;
    return (
      <div className="app-project-settings app-project-settings-custom">
        {
          appState.isWriteAccessRole() &&
          <a className="l-edit" href="#" onClick={this.editProjectBtnCallback.bind(this)}>
            {t('settings.edit', 'Redigera')}
          </a>
        }
        <div className="content-left">
          <div onClick={(e) => this.expandMoreInfo(e)}>
            <AppLabel headline={t('settings.headline.name', 'Projektnamn')}>
              <input readOnly disabled name="name" value={this.state.name || ""} onChange={this.dummyOnChange.bind(this)}/>
            </AppLabel>
            <AppLabel headline={t('settings.headline.projectNo', 'Projektnummer')}>
              <input readOnly disabled name="number" value={this.state.number || ""} onChange={this.dummyOnChange.bind(this)}/>
            </AppLabel>
            <AppLabel headline={t('settings.headline.customer', 'Beställare')}>
              <input readOnly disabled name="customer" value={this.state.customer || ""} onChange={this.dummyOnChange.bind(this)}/>
            </AppLabel>
            <AppLabel headline={t('settings.headline.province', 'Ort/kommun')}>
              <input readOnly disabled name="province" value={this.state.province || ""} onChange={this.dummyOnChange.bind(this)}/>
            </AppLabel>
            <AppLabel headline={t('settings.headline.entreprenad', 'Entreprenad')}>
              <input readOnly disabled name="entreprenad" value={this.state.entreprenad || ""} onChange={this.dummyOnChange.bind(this)}/>
            </AppLabel>
            <AppLabel headline={t('settings.headline.estCost', 'Estimerad projektkostnad i MSEK')}>
              <input readOnly disabled name="estCost" value={this.state.estimatedCost || ""} onChange={this.dummyOnChange.bind(this)}/>
            </AppLabel>
            <AppLabel headline={t('settings.headline.projectType', 'Projekttyp')}>
              <input readOnly disabled name="projectType" value={this.state.projectType || ""} onChange={this.dummyOnChange.bind(this)}/>
            </AppLabel>
            <AppLabel headline={t('settings.headline.phase', 'Skede')}>
              <input readOnly disabled name="phase" value={this.state.phase || ""} onChange={this.dummyOnChange.bind(this)}/>
            </AppLabel>
            <AppLabel headline={t('settings.headline.responsible', 'Medarbetare')} class="employees">
              {(() => {
                const responsible = this.props.currentProject?.responsible;
                return responsible ? (
                  <div className="employee" key={responsible._id}>
                    <CustomAvatar src={responsible.avatarUrl} alt={responsible.name} />
                    <label>{responsible.name}</label>
                  </div>
                ) : (
                  <input readOnly disabled value="" onChange={this.dummyOnChange.bind(this)}/>
                );
              })()}
            </AppLabel>
          </div>
          <AppLabel headline={t('settings.headline.employees', 'Medarbetare')} class="employees">
            {this.state?.members && this.state.members.map((v) => {
              const id = v._id;
              if (!id) return null;
              const role = v.roles?.join(", ");
              const name = v.name ;
              const avatarUrl = this.props.users.find(user => user.value === id.toString())?.avatarUrl;
              return (
                <div className="employee" key={id}>
                  <CustomAvatar src={avatarUrl} alt={name} />
                  <label>{role ? `${name} (${role})` : name}</label>
                </div>
              );
            })}
          </AppLabel>
        </div>
      </div>
    );
  }
}

export default withTranslation('projects')(AppProjectSettings);
